import jsuper from '@/assets/js/jsuperV2.js'
import sunny from '@/assets/js/sunny.js'
import { getUrlParams } from './tool'
export default function useSuperSdk() {
  // 获取superID
  const getSuperID = () => {
    return new Promise((resolve, reject) => {
      // console.log(process.env, 66666666);

      let ciphertext = process.env.VUE_APP_ciphertext

      // 判断是否在微信 / 浏览器中
      if (sunny.helper.browser.weixin) {
        ciphertext

        let sourceId = getUrlParams(location.href, 'sourceId')

        let openId
        if (sourceId) {
          openId = sunny.weixin.getUserOpenId(process.env.VUE_APP_UserOpenIdUrl, { sourceId }, process.env.VUE_APP_pwd, '2')
        } else {
          openId = sunny.weixin.getUserOpenId(process.env.VUE_APP_UserOpenIdUrl, '', process.env.VUE_APP_pwd, '2')
        }

        resolve({ openId })
      } else {
        // 浏览器
        ciphertext
        jsuper.config({
          ciphertext,
          success: () => {
            jsuper.userInfo({
              success: async (data) => {
                if (data.identity) {
                  resolve(data)
                }
              },
            })
          },
          fail: function() {
            reject('登录失败，请稍后再试。')
          },
        })
      }
      resolve({ identity: '' })
    })
  }

  const setShare = (title, link, desc) => {
    sunny.weixin.onMenuShareTimeline({
      title: title,
      link: link,
      // link: 'http://a.super.cn/generatingTimetable2/#/',
      // link: 'http://192.168.13.27:8080/',
      imgUrl: 'https://www.super.cn/logo3x.png',
      success: function() {
        sunny.ui.toast('分享成功！'), a()
      },
      cancel: function() {},
    })

    sunny.weixin.onMenuShareAppMessage({
      title: title,
      link: link,
      // link: 'http://a.super.cn/generatingTimetable2/#/',
      // link: 'http://192.168.13.27:8080/',
      imgUrl: 'https://www.super.cn/logo3x.png',
      desc: desc,
      success: function() {
        sunny.ui.toast('分享成功！'), a()
      },
      cancel: function() {},
    })
  }
  // 设置分享面板
  // http://192.168.13.27:8080 本地
  // const setSharePlatform = () => {
  //     jsuper.shareItems({
  //         data: {
  //             platform: ['weixinTimeline', 'weixinSession', 'paper'],
  //         }
  //     })
  //     var methods = [
  //         {
  //             method: 'shareWeixinTimelineConfig',
  //             tag: '朋友圈',
  //         },
  //         {
  //             method: 'shareWeixinSessionConfig',
  //             tag: '微信朋友',
  //         },
  //         {
  //             method: 'sharePaperConfig',
  //             tag: '小纸条',
  //         },
  //     ]
  //     methods.map((item) => {
  //         var m = item.method
  //         var t = item.tag
  //         jsuper[m].call(window, {
  //             data: {
  //                 title: '测试分享',
  //                 content: '一键了解以后要上什么课，安利你也来玩！',
  //                 titleUrl: 'http://a.super.cn/mecoqa/#/',
  //                 shareUrl: 'http://a.super.cn/mecoqa/#/',
  //                 shareImgUrl: 'https://a.super.cn/mecoluck/statics/images/meco_logo.png',
  //                 icon: 'https://a.super.cn/mecoluck/statics/images/meco_logo.png',
  //             },
  //             success: function () { },
  //             fail: function () {
  //                 alert('分享失败' + t)
  //             },
  //         })
  //     })
  // }

  // 展示分享面板
  const share = () => {
    jsuper.showShareMenu()
  }
  return {
    getSuperID,
    // setSharePlatform,
    share,
    setShare,
  }
}
